"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildClassElementMetadataFromTypescriptParameterType = buildClassElementMetadataFromTypescriptParameterType;
const ClassElementMetadataKind_1 = require("../models/ClassElementMetadataKind");
function buildClassElementMetadataFromTypescriptParameterType(type) {
    return {
        isFromTypescriptParamType: true,
        kind: ClassElementMetadataKind_1.ClassElementMetadataKind.singleInjection,
        name: undefined,
        optional: false,
        tags: new Map(),
        value: type,
    };
}
//# sourceMappingURL=buildClassElementMetadataFromTypescriptParameterType.js.map